import { FC } from "react";
import PageSection from "../../parts/StaticPageSection";
import { Helmet } from "react-helmet";
import { LecalSection } from "../../parts/LecalSection";

export const TermsOfServicePage: FC = () => {
  return <>
    <Helmet>
      <title>利用規約 - Drop AI</title>
      <meta name="description" content="Drop AIの利用規約を確認できます。" />

      <meta property="og:url" content="https://drop4i.com/terms-of-service" />
      <meta property="og:type" content="website" />
      <meta property="og:title" content="利用規約 - Drop AI | 無料で使えるAI画像生成ツール" />
      <meta property="og:description" content="Drop AIの利用規約を確認できます。" />
    </Helmet>
    <PageSection title="Drop AI サービス利用規約">
      <div className="whitespace-pre-line">
        <div>
          この利用規約（以下「本規約」といいます。）は、株式会社 GO TO MARKET（以下「当社」といいます。）が提供するDrop AI（ https://drop4i.com、以下「本サービス」といいます。）をご利用いただく際の利用条件、本サービスの利用者が遵守すべき事項、及び利用者と当社との権利義務関係等を定めるものです。本サービスの利用にあたっては、本規約が適用されます。本規約に同意される場合にのみ本サービスをご利用ください。本サービスを利用した場合、本規約に同意したとみなします。
        </div>

        <LecalSection title="第1条（適用）" value={`1. 本規約は、本サービスの利用者と当社との間の本サービスの利用に関わる一切の関係に適用されます。
2. 当社が本サービス上で掲載する本サービスに関する説明・注意事項等の記載は、本規約の一部を構成するものとします。
3.本規約の規定内容と、本規約外における本サービスに関する説明・注意事項等の記載内容が異なる場合には、本規約の規定が優先して適用されます。`}></LecalSection>

        <LecalSection title="第2条（登録）" value={`利用者は、当社が別途定める方法により、本サービスのアカウント登録を行うものとします。利用者とは、本サービスのアカウント登録を完了した者を意味します。`}></LecalSection>

        <LecalSection title="第3条（アカウントの管理）" value={`1.利用者は、本サービスのアカウントを自己の責任において厳格に利用・管理するものとし、一切の責任を負うものとします。
2.利用者は、いかなる場合でも、アカウントを、第三者に譲渡、承継、共有、貸与、開示又は漏洩してはならず、第三者に利用させてはなりません。当社は、アカウントが第三者によって使用されたことで生じた損害について、当社の故意又は重大な過失による場合を除き、一切の責任を負いません。
3. アカウントを用いてなされた本サービスの利用は、当該アカウントを管理すべき利用者による行為とみなします。また、これにより生じる責任は全て利用者が負うものとします。但し、当社の故意又は重大な過失による場合はこの限りではありません。`}></LecalSection>

        <LecalSection title="第4条（本サービスの内容と利用者の自己責任等）" value={`1.本サービスは、利用者が入力（選択を含む、以下同じ。）した言語、画像等の情報による指示に基づき生成AIにより画像が自動的に生成されるサービスです。利用者は、自己の責任をもって本サービスを利用するものとし、本サービスの利用を通じて生成した画像の利用及びその結果について、一切の責任を負います。当社は、本サービスの利用を通じて生成された画像について、第三者の知的財産権、肖像権、プライバシーの権利、名誉、その他の権利又は利益を侵害しないことやその適法性等を何ら保証しません。利用者は、本サービスの利用を通じて生成した画像について、自己の責任をもって、第三者の権利利益の侵害の有無やその適法性等を調査し、適切に利用しなければなりません。
2. 本サービスには、当社が別途定めるプランに応じた保存期間内のみ生成画像を保存する機能がありますが、当該機能は一時的に生成画像を保存することにより本サービスの利用を補助するものにすぎず、利用者は、自己に必要な生成画像は自己の責任で保全するものとします。当社は、各プランに応じた保存期間内に生成画像が滅失・毀損した場合であっても、一切の責任を負いません。
3.利用者が本サービスの利用を通じて生成した画像に起因又は関連して利用者と第三者の間において紛争が生じた場合、利用者は自己の責任と費用をもって処理、解決するものとし、当社は一切の責任を負いません。
4. 利用者が本サービスの利用を通じて生成した画像に起因又は関連して当社が損害を被った場合は、利用者は、当社に対して、当該損害（合理的な範囲の弁護士費用を含みます。）の賠償を行うものとします。
5. 本サービスに関し、以下の各号の事項を利用者はあらかじめ承諾します。
(1)本サービスのレイアウトやデザインを含むユーザーインターフェースおよびユーザーエクスペリエンス等を事前の予告なく変更する場合があること
(2)本サービスの内容や機能等を事前の予告なく変更又は廃止する場合があること
(3)本サービスの利用条件等を事前の予告なく変更する場合があること`}></LecalSection>

        <LecalSection title="第5条（外部連携サービス）" value={`1.利用者は、本サービスの利用にあたり、本規約のほか、本サービスと連携している当社以外の第三者により提供されるサービス等（以下「外部連携サービス」といいます。）の定める利用規約その他の条件を遵守するものとします。
2.当社は、外部連携サービスが利用者の特定の目的に適合すること、期待する機能・商品的価値・正確性・有用性を有すること、利用者による外部連携サービスの利用が利用者に適用のある法令又は業界団体の内部規則等に適合すること、継続的に利用できること、及び不具合が生じないことについて、何ら保証しません。
3.利用者は、自己の責任において、外部連携サービスを利用するものとし、外部連携サービスに起因又は関連する不具合、損害、紛争等について、利用者は自己の責任と費用をもって処理、解決するものとし、当社は一切の責任を負いません。`}></LecalSection>

        <LecalSection title="第6条（禁止事項）" value={`利用者は、本サービスの利用にあたり、以下の各号のいずれかに該当する行為又は該当するおそれのある行為をしてはなりません。
(1)法令に違反する行為又は犯罪行為に関連する行為
(2)当社又は本サービスに虚偽の情報を申告・入力・指示等する行為
(3)公序良俗に反する行為
(4)当社又は第三者の知的財産権、肖像権、プライバシーの権利、名誉、その他の権利又は利益を侵害する行為
(5)虚偽の情報を流布させる行為
(6)本サービスの利用にあたり、以下に該当し、又は該当すると当社が判断する言語、画像等の情報を入力・指示等すること
・当社又は第三者の知的財産権、肖像権、プライバシーの権利、名誉、その他の権利又は利益を侵害する情報
・暴力的又は残虐な表現を含む情報
・コンピューター・ウィルスその他の有害なコンピューター・プログラムを含む情報
・当社又は第三者の名誉又は信用を毀損する表現を含む情報
・虚偽の情報
・わいせつな画像や表現を含む情報
・差別を助長する表現を含む情報
・自殺、自傷行為を助長する表現を含む情報
・薬物の不適切な利用を助長する表現を含む情報
・反社会的な表現を含む情報
・他人に不快感を与える表現を含む情報
(7)当社又は本サービスのネットワーク又はシステム等に過度な負荷をかける行為
(8)当社又は本サービスの運営に支障を与える行為
(9)当社又は本サービスのネットワーク又はシステム等への不正アクセス、その他セキュリティを侵害するような行為
(10)本サービスのシステム又はソースコードを解析又は転用する行為
(11)他の利用者のアカウントを使用する行為又はその入手を試みる行為
(12)他の利用者の利用を妨害する行為
(13)当社若しくは本サービス又は他の利用者のデータを閲覧、変更、改竄、削除する行為
(14)当社若しくは第三者になりすます行為
(15)当社又は第三者に不利益、損害、不快感を与える行為
(16)本規約に違反する行為又は本規約外における本サービスに関する説明・注意事項等に抵触する行為
(17)外部連携サービスが定める利用規約、プライバシーポリシーその他の規約に違反する行為
(18)本サービスを利用して第三者に新たなサービスを提供等する行為
(19)当社が認める方法以外で本サービスを利用する行為
(20)前各号の行為を直接又は間接に惹起し、又は容易にする行為
(21)前各号の行為を試みること
(22)その他、当社が不適切と判断する行為`}></LecalSection>

        <LecalSection title="第7条（本サービスの停止・中断）" value={`1. 当社は、以下のいずれかに該当する場合には、利用者に事前に通知することなく、本サービスの全部又は一部の提供を停止又は中断できるものとします。
(1)本サービスにかかるシステム点検又は保守作業を定期的又は緊急に行う場合
(2)システムに負荷が集中した場合
(3)不正アクセス、サイバー攻撃の発生等、セキュリティを確保する必要が生じた場合
(4)コンピューター、通信回線等の障害等により本サービスの運営が困難となった場合
(5)画像生成AIのライセンサーを含む外部連携サービス等に、トラブル、サービス提供の中断、停止又は廃止が生じた場合や本サービスとの連携の停止又は仕様変更等が生じた場合
(6)地震、落雷、火災、風水害、停電、天災地変などの不可抗力により本サービスの運営が困難となった場合
(7)法令又は政府機関の要請等により本サービスの運営が困難となった場合
(8)その他、当社が停止又は中断を必要と判断した場合
2. 当社は、本条に基づいてなされた本サービスの停止又は中断によって、利用者に生じた不利益・損害について、理由を問わず、一切の責任を負いません。`}></LecalSection>

        <LecalSection title="第8条（本サービスの変更・廃止）" value={`1.当社は、当社が必要と判断する場合には、本サービスの全部又は一部を変更又は廃止できるものとします。
2.本サービスの全部を廃止する場合には、当社は、本サービスサイト内の適宜の場所への掲示又は当社が適当と判断する方法により、廃止日の２か月前までに利用者に通知するものとします。但し、緊急の場合、当社は、当該通知をすることなく、本サービスの全部を廃止できるものとし、事後速やかに本サービスサイト内の適宜の場所への掲示又は当社が適当と判断する方法により、利用者に通知するものとします。
3.当社は、本条に基づいてなされた本サービスの全部又は一部の変更又は廃止によって、利用者に生じた不利益・損害について、理由を問わず、一切の責任を負いません。`}></LecalSection>

        <LecalSection title="第9条（サブスクリプション）" value={`1. 有償のサブスクリプションプランの内容は当社が別途定める記載によります。利用者は、当社が提供する有償のサブスクリプションプランを利用する場合、当社が定めるプランの内容に応じた利用料金を、当社が指定する支払い方法により、支払うものとします。
2.利用者から有償のサブスクリプションプランをその期間の途中で解除又は解約することはできません。有償のサブスクリプションプランの期間の途中で解除又は解約を希望されても、利用料金は返金されませんのでご注意ください。
3.利用者は、有償のサブスクリプションプランの自動更新の停止を希望する場合、当社が定める方法により、当社が定める期限までに、自動更新停止の手続を行うこととします。当社が定める方法により、当社が定める期限までに、自動更新停止の手続を完了しない場合、同一の内容で自動更新となります。
4. 有償のサブスクリプションプランの期間終了後は、当該プランのサービスは利用できなくなります。
5. 有償のオプションの内容は当社が別途定める記載によります。利用者は、当社が提供する有償のオプションを利用する場合、当社が定めるオプションの内容に応じた利用料金を、当社が指定する支払い方法により、支払うものとします。また、利用者から有償のオプションを解除又は解約することはできません。`}></LecalSection>

        <LecalSection title="第10条（利用者からのアカウントの削除）" value={`利用者が、本サービスのアカウントの削除を希望する場合、当社が定める方法によりアカウントの削除を行うものとします。本サービスのアカウントを削除した場合、利用者は、本サービスの全てを利用できなくなり、本サービスに関する全てのデータ（保存期間内の生成画像を含む。）やその他の情報にもアクセスができなくなります。`}></LecalSection>

        <LecalSection title="第11条（強制的なアカウントの利用停止・削除）" value={`1.当社は、利用者が以下の各号のいずれかに該当する場合、当該利用者の承諾を得ることなく、当該利用者の本サービスの全部又は一部の利用を停止し、又は当該利用者のアカウントを削除すること（以下総称して「利用停止等」といいます。）ができるものとします。
(1)利用者が本規約に違反した場合
(2)利用停止等の措置が必要であると合理的に認められる場合
2. 当社は、本条に基づいてなされた本サービスの全部又は一部の利用停止等によって、利用者に生じた不利益・損害について、理由を問わず、一切の責任を負いません。`}></LecalSection>

        <LecalSection title="第12条（遅延損害金）" value={`利用者が当社に対する金銭債務の支払いを遅滞した場合、利用者は、当社に対し、支払期日の翌日から支払済みに至るまで、年14.6％の割合による遅延損害金を支払うものとします。`}></LecalSection>

        <LecalSection title="第13条（知的財産権等の帰属）" value={`本サービスに関する知的財産権（特許権・実用新案権・意匠権・著作権・商標権その他の一切の知的財産権）及びその他の権利は当社又は当社に許諾した第三者に帰属するものであり、利用者に対してこれらの権利を譲渡するものではなく、また、本規約に定める以上の許諾を行うものではありません。`}></LecalSection>

        <LecalSection title="第14条（免責及び損害賠償の制限）" value={`1.当社は、本規約の各条項において保証しないとされている事項、責任を負わないとされている事項、利用者の責任とされている事項については、一切の責任を負いません。
2.本サービスに起因又は関連して当社が損害賠償責任を負う場合であっても、当社の故意又は重大な過失による場合を除き、その損害賠償責任の範囲は、債務不履行責任、不法行為責任、その他法律上の請求原因の如何を問わず、当社の責に帰すべき事由により利用者が現実に被った直接かつ通常の損害に限定され、当社は、付随的損害、間接損害、特別損害、将来の損害及び逸失利益等にかかる損害については、賠償する責任を負いません。
3. 本サービスに起因又は関連して当社が損害賠償責任を負う場合であっても、当社の故意又は重大な過失による場合を除き、その損害賠償責任の範囲は、債務不履行責任、不法行為責任、その他法律上の請求原因の如何を問わず、利用者が当社に対して既に支払った直近過去３か月分の本サービスに関する利用料金に相当する額を上限とします。
4. 当社は、本サービスが利用者の特定の目的に適合すること、期待する機能・商品的価値・正確性・有用性を有すること、利用者による本サービスの利用が利用者に適用のある法令又は業界団体の内部規則等に適合すること、継続的に利用できること、及び不具合が生じないことについて、何ら保証しません。
5. 当社は、明示、黙示を問わず、本サービスの内容及びその提供につき如何なる保証も行うものではありません。本サービスの内容又はその提供に誤り又は不具合等が発見された場合、当社の判断で本サービスのアップデートをする場合がありますが、かかるアップデートを行う義務を当社が負うものではありません。
6. 当社は、本サービスの利用を通じて生成された画像について、第三者の知的財産権、肖像権、プライバシーの権利、名誉、その他の権利又は利益を侵害しないことやその適法性等を何ら保証しません。
7.本サービスには、当社が別途定めるプランに応じた保存期間内のみ生成画像を保存する機能がありますが、当社は、各プランに応じた保存期間内に生成画像が滅失・毀損した場合であっても、一切の責任を負いません。
8.利用者と他の利用者又はその他の第三者との間において生じた紛争等については、利用者は自己の責任と費用をもって処理、解決するものとし、当社は一切の責任を負いません。
9. 画像生成AIのライセンサーを含む外部連携サービス等の第三者の運営するサービスに起因又は関連する不具合、損害、紛争等について、当社は一切の責任を負いません。
10.画像生成AIのライセンサーを含む外部連携サービス等の第三者のシステム等の仕様や規約等が変更されたことにより、利用者が本サービスを利用することが困難又は不可能となった場合でも、利用者は、当社に支払った利用料金について、当社に対し返金を求めることができないものとします。また、これにより、利用者又は第三者が被った不利益・損害については、当社は一切の責任を負いません。
11.本サービスを利用するために必要なハードウェア、ソフトウェア、及びインターネット通信回線等その他の設備については、利用者が自ら用意するものとします。当該設備等に起因又は関連して利用者又は第三者が被った不利益・損害については、当社は一切の責任を負いません。`}></LecalSection>

        <LecalSection title="第15条（通知・お問い合わせ）" value={`1. 本サービスに関する当社から利用者への通知は、本サービスサイト内の適宜の場所への掲示、又はメールアドレスへのメール、若しくは当社が適当と判断する方法により行うものとします。当社から利用者への通知は、当社からの発信によってその効力が生ずるものとします。
2. 本サービスに関する利用者から当社へのお問い合わせは、本サービス又は当社コーポレートサイト内に設置するお問い合わせフォームより行うものとします。`}></LecalSection>

        <LecalSection title="第16条（個人情報の取扱い）" value={`1. 本サービスに関する個人情報の取扱いについては、別途プライバシーポリシー（https://drop4i.com/privacypolicy ）の定めによるものとし、利用者はこのプライバシーポリシーに従って当社が利用者の個人情報を取扱うことについて同意するものとします。
2. 当社は、利用者が当社に提供した情報、データ等を、個人を特定できない形での統計的な情報として、当社の裁量で、利用及び公開することができるものとし、利用者はこれに異議を述べないものとします。`}></LecalSection>

        <LecalSection title="第17条（利用規約の変更）" value={`当社は、当社が必要と認めた場合は、本規約を変更できるものとします。本規約を変更する場合、変更後の本規約の内容及びその効力発生時期を本サービスサイト内の適宜の場所への掲示又は当社が適当と判断する方法により周知するものとし、変更後の本規約は、当該効力発生時期が到来した時点で効力を生じるものとします。また、利用者が当該効力発生時期以後に本サービスを利用した場合、変更後の本規約に同意したとみなします。`}></LecalSection>
        <LecalSection title="第18条（反社会的勢力の排除）" value={`1.利用者は、当社に対し、以下の各号の事項について現在及び将来にわたって誓約します。
(1)自らが反社会的勢力に該当しないこと
(2)反社会的勢力との間で社会的に非難される関係性を有していないこと
(3)暴力的・脅迫的な要求行為、業務妨害・信用毀損行為その他違法行為をしていないこと
(4)反社会的勢力に自らの名義を貸していないこと
(5)反社会的勢力への利益供与をしていないこと
2.利用者が前項に違反した場合、当社は、当該利用者の本サービスの全部又は一部の利用の停止や当該利用者のアカウントの削除等の措置をすることができるものとし、当社は、当該措置によって、利用者に生じた不利益・損害について、理由を問わず、一切の責任を負いません。`}></LecalSection>
        <LecalSection title="第19条（権利義務の譲渡禁止等）" value={`1.利用者は、本規約に基づく契約上の地位又は本規約に基づく権利若しくは義務を、第三者に対し、譲渡、移転、承継、担保設定その他の処分をしてはならないものとします。
2.当社は、本サービスにかかる事業を第三者に譲渡し、又は承継する場合、本規約に基づく当社と利用者との間の契約上の地位及び本規約に基づく権利及び義務、並びに利用者に関する情報を当該第三者に譲渡又は承継できるものとし、利用者は、これに予め同意するものとします。`}></LecalSection>
        <LecalSection title="第20条（分離可能性）" value={`本規約のいずれかの条項又はその一部が、法令等により無効又は執行不能と判断された場合であっても、本規約の残りの規定は継続して完全に効力を有するものとします。`}></LecalSection>
        <LecalSection title="第21条（協議解決）" value={`当社及び利用者は、本規約に定めのない事項又は本規約の解釈に疑義が生じた場合には、誠意をもって協議し、これを処理解決するよう努めます。`}></LecalSection>
        <LecalSection title="第22条（準拠法、裁判管轄）" value={`1. 本規約の準拠法は日本法とします。
2. 本規約に起因し、又は関連する一切の紛争については、東京地方裁判所を第一審の専属的合意管轄裁判所とします。`}></LecalSection>

        <div className="mt-10">
{`2025年2月5日 制定
2025年12月10日 改定`}
        </div>
      </div>
    </PageSection>
  </>;
}
